import { NgModule } from '@angular/core';
import { AddressTypePipe } from './address-type.pipe';

@NgModule({
  declarations: [AddressTypePipe],
  exports: [AddressTypePipe]
})
export class AddressTypeModule {}
